// eslint-disable-next-line import/prefer-default-export
export const BATCH_FILE = {
  parser: {
    support: '.txt,.sdf,.rdf',
    in: '/app/import/batch/{queryId}', // Ping server to start parse file
    out: '/user/import/info', // Result of parsing
  },
  structureOptions: {
    DEFAULT_QUERY_TYPE: 'exact',
    DEFAULT_QUERY_TYPE_OPTION: { name: 'searchBy', value: 'exact' },
  },
};
